import axios from "axios";
import {
  clearAuthSession,
  getStoredAuthToken,
  isTokenExpired,
  LOGIN_PATH,
} from "helpers/authSession";

const AUTH_ROUTES = [
  "/login",
  "/register",
  "/forgot-password",
  "/reset-password",
  "/verify",
  "/policy",
];

const AUTH_ENDPOINTS = [
  "/donate/auth/login",
  "/donate/auth/register",
  "/donate/auth/send-verify-code",
  "/donate/auth/verify-code",
  "/donate/auth/forgot-password",
  "/donate/auth/reset-password",
  "/public/forgot-password",
  "/donate/public/reset-password",
];

let isRedirectingToLogin = false;

const isAuthRoute = () => {
  if (typeof window === "undefined") {
    return false;
  }

  return AUTH_ROUTES.some((route) => window.location.pathname === route);
};

const isAuthEndpoint = (url = "") => {
  return AUTH_ENDPOINTS.some((endpoint) => url.includes(endpoint));
};

const redirectToLogin = () => {
  if (typeof window === "undefined" || isRedirectingToLogin) {
    return;
  }

  clearAuthSession();

  if (isAuthRoute()) {
    return;
  }

  isRedirectingToLogin = true;
  window.location.replace(LOGIN_PATH);
};

const axiosInstance = axios.create({
  // baseURL: "",
  timeout: 10000, // Set timeout (optional)
  headers: {
    "Content-Type": "application/json",
    authorization: "Bearer " + process.env.REACT_APP_USER_GUEST_TOKEN,
  },
});

axiosInstance.interceptors.request.use(
  (config) => {
    const token = getStoredAuthToken();
    const url = config.url || "";

    if (token && !isAuthEndpoint(url) && isTokenExpired(token)) {
      redirectToLogin();
      return Promise.reject(new Error("Token expired"));
    }

    return config;
  },
  (error) => Promise.reject(error),
);

axiosInstance.interceptors.response.use(
  (response) => response,
  (error) => {
    const status = error?.response?.status;
    const url = error?.config?.url || "";
    const message = [
      error?.response?.data?.message,
      error?.response?.data?.error,
    ]
      .filter(Boolean)
      .join(" ")
      .toLowerCase();
    const isExpiredResponse =
      status === 401 ||
      status === 419 ||
      status === 440 ||
      message.includes("jwt expired") ||
      message.includes("token expired");

    if (isExpiredResponse && !isAuthEndpoint(url)) {
      redirectToLogin();
    }

    return Promise.reject(error);
  },
);

export default axiosInstance;
